import api from "../../index";

export const GetPayrollClientApi = () => api.post('payroll-client-list');
export const getClientWiseEmployees = (data)=>api.post('get-payroll-employee',data);
export const EmployeePayrollHistory = (data)=> api.post("employee-payroll-history",data)
export const GetPayrollData = (data)=> api.post("get-payroll-data",data)
export const ViewPayrollHistoryApi = (data)=> api.post("get-payroll-data", data)
export const updatePayrollEmpStatus = (data)=> api.post("update-payroll-employee-status",data)
export const uploadPayrollDoc = (data, header)=> api.post("upload-payroll-document",data, header)
export const ExportPayrollApi = (data, headers)=> api.post("export-payroll-data", data, headers)